import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import { Label, FileName, Button } from '../styles';
import YoutubeLinkPanel from '../../YoutubeLinkPanel';
import Utils from '../../../../../utils';

interface MainViewProps {
	iconName: string;
	defaultLabel: string;
	label: string;
	externalLink: string;
	isExternalLinkActive: boolean;
	isResetButtonDisplayed: boolean;
	onReplaceClick: () => void;
	onResetClick: () => void;
	onExternalLinkChange: (value: string) => void;
}

const MainView = ({
	iconName,
	defaultLabel,
	label,
	externalLink,
	isExternalLinkActive,
	isResetButtonDisplayed,
	onReplaceClick,
	onResetClick,
	onExternalLinkChange,
}: MainViewProps) => (
	<>
		{isExternalLinkActive
			? (
				<YoutubeLinkPanel
					value={externalLink}
					onChange={onExternalLinkChange}
				/>
			)
			: (
				<>
					<Label value="messages.your_file" />
					<FileName>
						{Utils.getSvgIcon(iconName)}
						{label || <Translate value={defaultLabel} />}
					</FileName>
				</>
			)
		}
		{isResetButtonDisplayed &&
			<Button
				type="button"
				onClick={onResetClick}
			>
				<Translate value="messages.reset_to_default" />
			</Button>
		}
		<Button
			type="button"
			onClick={onReplaceClick}
		>
			<Translate value="messages.replace" />
		</Button>
	</>
);

export default MainView;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/MediaPanel/MainView/index.tsx